import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from '../../../errors/api-error-handler';
import { EventDetailsInitialStateType, EventDetailsType } from '../../../models/events/event-details-modal';
import { RightSideTrailInitialStateType, RightSideTrailType } from "../../../models/right-side-trail-model";
import EventRightSideRelatedEventsService from '../../../services/right-side/event-right-side-related-events.service';

const initialState: RightSideTrailInitialStateType = {
    rightSideFeaturedBooksData: [],
    rightSideFeaturedLearningData: [],
    rightSideTrendingNewsData: [],
    rightSidePopularEventsData: [],
    Loading: true,
    Error: undefined,
};


export const retrieveEventRightSideRelatedEvents = createAsyncThunk('EventRightSideRelatedEvents/retrieve',
    async (eventPath: string, { rejectWithValue }) => {
        try {

            const response = await EventRightSideRelatedEventsService.getEventRightSideRelatedEventsService(eventPath)
            return [response.data]

        } catch (error: any) {
            if (!error.response) {
                throw error
            }
            return rejectWithValue(error.response.status)
        }
    }
)

const EventRightSideRelatedEventsSlice = createSlice({
    name: 'EventRightSideRelatedEvents',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(retrieveEventRightSideRelatedEvents.pending, (state) => {
                state.Loading = true;
            })
            .addCase(retrieveEventRightSideRelatedEvents.fulfilled, (state, action) => {
                if (action.payload) {
                    state.Loading = false;
                    state.rightSidePopularEventsData = action.payload as RightSideTrailType[];
                }
            })
            .addCase(retrieveEventRightSideRelatedEvents.rejected, (state, { payload }) => {
                state.Loading = false;
                state.Error = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default EventRightSideRelatedEventsSlice.reducer;
